import React from 'react'

const defaultValue = {
  locale: 'en',
  userLoggedIn: false,
  pageConfigLoaded: false,
  extractingCoreStyles: false,
  dccSoftwares: [],
  showGenerationErrorDetails: false,
  modelReadyToasterEnabled: false,
  segmentationFlowEnabled: false,
  enableHunyuanSegmentation: false,
  enableMeshyRemesh: false,
  enableHunyuanProvider: false,
  designerAssistEnabled: false,
  ideationFlowEnabled: false,
  imageSearchOnIdeationFLowEnabled: false,
  communityGalleryFilterOptions: {
    visibleCategories: [],
    sortOptions: [],
  },
  communityGalleryInitialModels: null,
}

const ThreeDStudioPageContext = React.createContext(defaultValue)

export default ThreeDStudioPageContext
